import {
  getContainerBorderColor,
  getControlBorderRadius,
  getSingleValueColor,
} from './helpers'

import { convertHexInRGBA } from '../../../lib/helpers'
import { theme } from '../../../theme'

import type { StylesConfig } from 'react-select'

export const customStyles: StylesConfig = {
  valueContainer: (provided, state) => ({
    ...provided,
    padding: state.hasValue && state.isMulti ? '8px' : '15px 14px',
    fontSize: '16px',
    lineHeight: '1.2',
    fontFamily: theme.fonts.mainFont,
    fontWeight: 'normal',
    minHeight: '48px',
    height: 'fit-content',
    gap: '2px',
    paddingRight: 0,
  }),
  singleValue: (provided, state) => ({
    ...provided,
    display: 'flex',
    flexWrap: 'nowrap',
    fontFamily: theme.fonts.mainFont,
    fontWeight: 'normal',
    color: getSingleValueColor(
      state.selectProps.menuIsOpen,
      state.isDisabled,
      theme
    ),
  }),
  control: (provided, state) => ({
    ...provided,
    border: `1px solid ${getContainerBorderColor(
      state.menuIsOpen,
      state.selectProps.error,
      theme
    )}`,
    transition: 'border-color 250ms ease',
    boxShadow: 'none',

    '&:hover': {
      borderColor: getContainerBorderColor(
        state.menuIsOpen,
        state.selectProps.error,
        theme
      ),
    },
    backgroundColor: state.isDisabled ? theme.colors.catskillWhite : 'white',
    borderRadius: state.menuIsOpen
      ? getControlBorderRadius(state.selectProps.menuPlacement === 'top')
      : '8px',
    ...(state.menuIsOpen && { borderBottom: 'none', paddingBottom: '1px' }),
    ...(state.selectProps.menuPlacement === 'top' && {
      borderBottom: `1px solid ${getContainerBorderColor(
        state.menuIsOpen,
        state.selectProps.error,
        theme
      )}`,
    }),
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  input: (provided, state) => ({
    ...provided,
    margin: 0,
    padding: 0,
    fontSize: '16px',
    lineHeight: '1.2',
    fontFamily: theme.fonts.mainFont,
    cursor: 'text',
    color: state.isDisabled
      ? theme.colors.slateGray
      : theme.colors.sapphireDark,
    visibility: state.isDisabled ? 'visible' : provided.visibility,
  }),
  menu: (provided, state) => ({
    ...provided,
    display: 'block',
    boxShadow: 'none',
    border: `1px solid ${getContainerBorderColor(
      true,
      state.selectProps.error,
      theme
    )}`,
    borderTop:
      state.menuPlacement === 'top'
        ? `1px solid ${getContainerBorderColor(
            true,
            state.selectProps.error,
            theme
          )}`
        : 'none',
    borderRadius: state.menuPlacement === 'top' ? '8px' : '0 0 8px 8px',
    paddingBottom: '20px',
    paddingTop: '4px',
    zIndex: 2,
    marginTop: '0px',
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '0 6px',
  }),
  option: (provided, { isSelected, isFocused }) => ({
    ...provided,
    display: 'flex',
    alignItems: 'center',
    margin: '1px 0',
    overflow: 'hidden',
    borderRadius: '4px',
    height: '33px',
    background:
      isFocused || isSelected
        ? convertHexInRGBA(theme.colors.slateGray, 0.1)
        : theme.colors.white,
    color: theme.colors.second,
    ':active': {
      ...provided[':active'],
      backgroundColor: convertHexInRGBA(theme.colors.slateGray, 0.5),
    },
    fontSize: '16px',
    fontFamily: theme.fonts.mainFont,
    fontWeight: isSelected ? 500 : 'normal',
    lineHeight: '20px',
    cursor: 'pointer',
  }),
  multiValue: (provided) => ({
    ...provided,
    background: theme.colors.catskillWhite,
    padding: '7px 10px',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    fontFamily: theme.fonts.mainFont,
    fontWeight: 'normal',
    fontSize: '16px',
    padding: '0',
    paddingLeft: '0',
    paddingRight: '8px',
    color: theme.colors.sapphireDark,
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    '&:hover': {
      opacity: 0.8,
      color: theme.colors.blueAura,
      backgroundColor: theme.colors.catskillWhite,
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    whiteSpace: 'nowrap',
    fontFamily: theme.fonts.mainFont,
    color: theme.colors.blueAura,
    fontWeight: 'normal',
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: 2,
    color: theme.colors.sapphireDark,
  }),
  menuPortal: (base) => ({ ...base, zIndex: 1000 }),
}
